// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.virtual-scroll-container[data-v-3906b446] {\n  height: 600px;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  margin: 10px 0;\n}\n.virtual-scroll-placeholder[data-v-3906b446] {\n  position: relative;\n}\n.virtual-scroll-content[data-v-3906b446] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n.listItem[data-v-3906b446] {\n  display: inline-block;\n  width: 5px;\n  height: 5px;\n  background: #000;\n  border-radius: 50%;\n  margin: 3px 5px;\n}\n", ""]);
// Exports
module.exports = exports;
